<template>
  <div class="home">
    <div class="physical-border">
      <div class="grid">
        <span class="hda-top-bar">
          <p class="title-text">Hypotension Decision Assist (HDA)&trade;</p>
          <div>
            <p class="time-text">{{ timestamp }}</p>
          </div>
        </span>
        <CaseReport
          class="content"
          surgeryType="Neuro"
          :startTime="startTime"
          :endTime="endTime"
          :sessionNumber="sessionNumber"
          :mapSignal="mapSignal"
          :trendSignals="trendSignals"
          :xMin="xMin"
          :xMax="xMax"
          :treatments="treatments"
          :title="caseTitle"
          :age="age"
          :height="height"
          :weight="weight"
        ></CaseReport>
      </div>
      <div id="brightness-filter" :style="{ opacity: filterOpacity }"></div>
    </div>
  </div>
</template>

<script>
import CaseReport from '../views/CaseReport'
import Papa from 'papaparse'

export default {
  name: 'CaseReportHome',
  data() {
    return {
      screen: 'launch',
      mapTrend: [],
      co: [],
      hr: [],
      svr: [],
      xMin: 0,
      xMax: 100,
      startTime: null,
      endTime: null,
      treatments: [],
      caseTitle: '',
      sessionNumber: 'ov9jp-1nlm2-98fv2',
      age: '75-79',
      height: '150cm',
      weight: '150kg'
    }
  },
  computed: {
    timestamp() {
      return this.$store.state.timestamp
    },
    filterOpacity() {
      return 1 - this.$store.state.brightness
    },
    mapSignal() {
      return [
        {
          points: this.mapTrend,
          name: 'MAP',
          color: '#00413B'
        }
      ]
    },
    trendSignals() {
      return [
        {
          points: this.co,
          name: 'CO',
          color: '#1B77D2'
        },
        {
          points: this.hr,
          name: 'HR',
          color: '#fcbc36'
        },
        {
          points: this.svr,
          name: 'SVR',
          color: '#d345da'
        }
      ]
    }
  },
  components: {
    CaseReport
  },
  methods: {
    numberCheck(x) {
      if (typeof x != 'number') {
        return NaN
      } else {
        return x
      }
    }
  },
  mounted() {
    Papa.parse('longevents.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: function(results) {
        // Load 15mins worth
        for (var i = 0; i < results.data.length - 1; i++) {
          this.treatments.push({
            id: i + 1,
            text: results.data[i]['Description'].split(':')[1],
            y: (i + 1) * 10 + 8,
            type: 'test',
            date: new Date(results.data[i]['Time'])
          })
        }
      }.bind(this)
    })
    // Parse local CSV file
    Papa.parse('longdata.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: function(results) {
        // Load 15mins worth
        const steps = results.data.length - 1
        var map = []
        this.co = []
        this.hr = []
        this.svr = []
        var i = 0
        for (i = 0; i < steps; i++) {
          map.push([i, this.numberCheck(results.data[i]['MAP'])])
          this.co.push([i, results.data[i]['nCO']])
          this.hr.push([i, results.data[i]['HR']])
          this.svr.push([i, results.data[i]['SVR']])
        }
        this.xMax = i
        this.xMin = 0
        this.mapTrend = map
        this.signal = map
        this.trendSignal = this.co
        this.systolicBP = Math.round(results.data[steps]['SystolicBP'])
        this.diastolicBP = Math.round(results.data[steps]['DiastolicBP'])
        this.meanBP = Math.round(results.data[steps]['MAP'])
        this.heartRate = Math.round(results.data[steps]['HR'])
        this.startTime = new Date(results.data[0]['Time'])
        this.caseTitle = this.startTime.toLocaleString('en-gb', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })
        this.endTime = new Date(results.data[results.data.length - 2]['Time'])
      }.bind(this)
    })
  }
}
</script>

<style scoped>
.home {
  width: 90vw;
  /* 90% of viewport vidth */
  height: 50.625vw;
  /* ratio = 9/16 * 90 = 50.625 */
  background-color: #010201;
  max-height: 90vh;
  max-width: 160vh;
  /* 16/9 * 90 = 160 */
  margin: 2% auto;
  position: relative;
  border-radius: 5%;
  border: 4px solid rgb(202, 201, 206);
}
.physical-border {
  position: absolute;
  top: 6%;
  bottom: 6%;
  right: 6%;
  left: 6%;
}
.grid {
  position: absolute;
  height: 100%;
  width: 100%;
  /* Grid */
  background: #add4c8;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 2.6% 97.4%;
}
.hda-top-bar {
  grid-row: 1;
  background-color: #00413b;
  font-size: 0.9vw;
}

.content {
  grid-row: 2;
}

.title-text {
  color: white;
  float: left;
  margin: 0 0 0 10px;
}
.time-text {
  color: white;
  float: right;
  margin: 0 10px 0 0;
}
#brightness-filter {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 9;
  background-color: black;
  pointer-events: none;
}
</style>
